import { forwardRef } from 'react';
import { Box, Divider } from '@mui/material';
import type { BoxProps, DividerProps } from '@mui/material';

type ToolbarFilterDividerProps = Omit<DividerProps, 'component'>;

export const ToolbarFilterRow = forwardRef<HTMLDivElement, BoxProps>(function ToolbarFilterRow(
  { sx, ...boxProps },
  ref
) {
  return (
    <Box
      ref={ref}
      sx={[
        {
          display: 'flex',
          justifyContent: { xs: 'center', sm: 'flex-end' },
          alignItems: 'center',
          flexWrap: { xs: 'wrap', sm: 'nowrap' },
          gap: 1,
          width: { xs: '100%', sm: 'max-content' },
          minWidth: 0,
          maxWidth: '100%',
          boxSizing: 'border-box',
          // DataGrid clips overflow; keep floating input labels inside its top edge.
          pt: 1.5,
          whiteSpace: { sm: 'nowrap' },
          mb: 1,
          '& > .MuiAutocomplete-root': {
            maxWidth: '100%',
            minWidth: 0,
            flexShrink: { sm: 1 },
          },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
      {...boxProps}
    />
  );
});

export const ToolbarFilterDivider = forwardRef<HTMLDivElement, ToolbarFilterDividerProps>(function ToolbarFilterDivider(
  { orientation = 'vertical', sx, ...dividerProps },
  ref
) {
  return (
    <Divider
      component="div"
      ref={ref}
      orientation={orientation}
      sx={[{ display: { xs: 'none', sm: 'block' }, mx: 1, border: 0 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
      {...dividerProps}
    />
  );
});
